import * as _ from "lodash";
import * as React from "react";
import { Container, Grid, Header, Segment, Sidebar } from "semantic-ui-react";
import { Base, Event, ResourceType } from "../Common/Base";
import BotSights from "../Query/BotSights";
import MessageType from "api/lib/data/interfaces/MessageType";

import "react-semantic-toasts/styles/react-semantic-alert.css";
import {
  BaseLayout,
  IBaseLayoutMatchParams,
  IBaseLayoutProps,
  IBaseLayoutState,
} from "../Common/BaseLayout";
import ListUsers from "../Query/ListUsers";
import QueryTabs from "../QueryTabs";
import TwilioConference from "../Query/TwilioConference";
import TwilioTokenRequest from "api/lib/data/interfaces/TwilioTokenRequest";
import Analysis from "api/lib/data/Analysis";
import MessageObject from "api/lib/data/interfaces/MessageObject";
import Analyses from "api/lib/data/Analyses";
import DeleteResource from "../Common/DeleteResource";
import { UpdateResource } from "../Common/UpdateResource";
import * as routes from "../../constants/routes";
import { IRoles } from "src/reducers/session";

interface IMatchParams extends IBaseLayoutMatchParams {
  analysisId: string;
  queryId: string;
}

export interface IAnalysisLayoutState extends IBaseLayoutState {
  analysis: Analysis;
  data: any;
  canEdit: boolean;
}

export default class AnalysisLayout extends BaseLayout<
  IBaseLayoutProps<IMatchParams>,
  IAnalysisLayoutState
> {
  private static getInitialState = () => {
    return {
      analysis: null,
      data: null,
      canEdit: false,
    };
  };
  constructor(props: IBaseLayoutProps<IBaseLayoutMatchParams>) {
    super(props);

    this.state = {
      ...BaseLayout.BASE_LAYOUT_INITAL_STATE,
      ...AnalysisLayout.getInitialState(),
    };
  }

  public render() {
    const { authUser, orgId, usersStatus } = this.props;
    const { analysisId, queryId } = this.props.match.params;
    const { data, analysis, canEdit } = this.state;
    if (!data) {
      return "";
    }
    return (
      <div>
        <Sidebar
          as={Segment}
          direction="left"
          animation="overlay"
          icon="labeled"
          vertical={true}
          visible={true}
          width="wide"
          className="analysis__sidebar__chat"
        >
          <Segment attached={true}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={10}>
                  <Header as="h3" style={{ marginBottom: "10px" }}>
                    {data.name}
                  </Header>
                </Grid.Column>
                <Grid.Column
                  width={6}
                  textAlign="right"
                  style={{ paddingRight: "5px" }}
                >
                  {data && canEdit && (
                    <React.Fragment>
                      <DeleteResource
                        {...this.props}
                        resource={{
                          id: this.props.match.params.analysisId,
                          name: data.name,
                          api: analysis,
                          type: Base.RESOURCE_LABEL[ResourceType.analysis],
                        }}
                        deleted={this.handleAnalysisDeleted}
                      />

                      <UpdateResource
                        {...this.props}
                        resource={{
                          id: this.props.match.params.analysisId,
                          name: data.name,
                          api: analysis,
                          type: Base.RESOURCE_LABEL[ResourceType.analysis],
                        }}
                        config={data}
                        updated={this.handleAnalysisUpdated}
                      />
                    </React.Fragment>
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>

            {/* <Popup
              trigger={<Button icon="add" onClick={this.handleClearQuery} />}
              content="Create new Query"
              inverted={true}
            /> */}

            {/* <Input
              fluid={true}
              size="mini"
              icon="search"
              name="searchTerm"
              placeholder="Search Messages"
            /> */}
          </Segment>
          <Segment attached={true} style={{ padding: "0 12px" }}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={14}>
                  <ListUsers
                    resource={{
                      id: analysisId,
                      name: data.name,
                      api: new Analyses(orgId),
                      type: Base.RESOURCE_LABEL[ResourceType.analysis],
                    }}
                    authUser={authUser}
                    orgId={orgId}
                    usersStatus={usersStatus}
                  />
                </Grid.Column>
                <Grid.Column width={2}>
                  <TwilioConference
                    roomName={`conf/${orgId}/${analysisId}`}
                    queryName={this.state.data.analysisName}
                    getToken={this.getTwilioToken}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
          <Segment
            attached={true}
            style={{ height: `calc(100% - 98px)` }}
            className="analysis__sidebar__tabs"
          >
            <BotSights
              {...this.props}
              doubts={null}
              datasourceMetadata={null}
              onAddMessage={this.handleAddMessage}
              analysis={analysis}
              messageType={MessageType.U2U}
              onVersionChange={this.handleVersionChange}
              onClearQuery={this.handleNewQuery}
              usersStatus={usersStatus}
            />
          </Segment>
        </Sidebar>
        <Container className="analysis__container__main">
          <QueryTabs
            {...this.props}
            analysisId={analysisId}
            queryId={queryId}
          />
        </Container>
      </div>
    );
  }

  public componentDidMount = () => {
    this.getData();
  };

  public componentDidUpdate = (prevProps: IBaseLayoutProps<IMatchParams>) => {
    if (
      this.props.match.params.analysisId !== prevProps.match.params.analysisId
    ) {
      this.getData();
    }
  };

  private checkRoleAndGetData = () => {
    const { orgId, match } = this.props;
    const analysisId = match.params.analysisId;
    const analyses = new Analyses(orgId);
    this.getAuthRolesForResource(analyses, analysisId, (roles: IRoles) => {
      if (roles) {
        if (roles && (roles.admin || roles.owner)) {
          this.setState({ canEdit: true });
        } else {
          this.setState({ canEdit: false });
        }
      }
    });
  };

  private getData = () => {
    const { orgId } = this.props;
    const { analysisId } = this.props.match.params;
    const analysis = new Analysis(orgId, analysisId);
    this.checkRoleAndGetData();
    this.getOnceListner(
      analysis.getConfig(),
      Event.Value,
      (snapshot: firebase.database.DataSnapshot) => {
        const data = snapshot.val();
        this.setState({ data, analysis });
      }
    );
  };

  private getTwilioToken = (callback) => {
    const req: TwilioTokenRequest = {
      audit: {
        createdBy: this.props.authUser.uid,
      },
    };
    const { analysis } = this.state;
    analysis
      .createTwilioToken(req)
      .then((reqRef: firebase.database.Reference) => {
        this.getListner(
          analysis.getTwilioToken(reqRef.key),
          Event.Value,
          callback
        );
      });
  };

  private handleNewQuery = () => {
    // TODO
  };

  private handleAddMessage = (value: string) => {
    const message: MessageObject = {
      content: value,
      type: MessageType.U2U,
      from: this.props.authUser.email,
      fromName: this.props.authUser.displayName,
      to: [],
      audit: {
        createdBy: this.props.authUser.uid,
      },
    };
    this.state.analysis.createMessage(message);
  };

  private handleVersionChange = (versionId: string) => {
    // TODO
  };

  private handleAnalysisDeleted = () => {
    const { history, orgId } = this.props;
    history.push(routes.ANALYSES(orgId));
  };

  private handleAnalysisUpdated = (newName: string) => {
    const { data } = this.state;
    data.name = newName;
    this.setState({ data });
  };
}



// WEBPACK FOOTER //
// ./src/components/Analysis/AnalysisLayout.tsx